export default {
  metasSite: state => state.metasSite,
  certificateConfig: state => state.certificateConfig,
  currentSite: state => state.currentSite,
  allSites: state => state.allSites,
  currentMember: state => state.currentMember,
  isDragging: state => state.isDragging,
  getModalWelcomeIsOpen: state => state.modalWelcomeIsOpen,
}
